export const bookingRouter = [
  {
    path: "booking",
    name: "booking",
    component: () => import("../pages/booking/BookingList.vue"),
    meta: { text: "$vuetify.layout.navigationSidebar.booking" },
  },
  {
    path: "booking/history/:id",
    name: "booking-history",
    component: () => import("../pages/booking/BookingList.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.bookingHistory",
      parent: {
        name: "Booking",
        disabled: false,
        path: "/booking",
        exact: true,
      },
    },
  },
  {
    path: "booking/create",
    name: "createbooking",
    component: () => import("../pages/booking/create-booking/CreateBooking.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.createBooking",
      parent: {
        name: "$vuetify.layout.navigationSidebar.booking",
        disabled: false,
        path: "/booking",
        exact: true,
      },
    },
  },
  {
    path: "booking/edit/:id",
    name: "editbooking",
    component: () => import("../pages/booking/edit-booking/EditBooking.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.editBooking",
      parent: {
        name: "$vuetify.layout.navigationSidebar.booking",
        disabled: false,
        path: "/booking",
        exact: true,
      },
    },
  },
  {
    path: "booking/detail/:id",
    name: "detailbooking",
    component: () => import("../pages/booking/detail-booking/DetailBooking.vue"),
    meta: {
      text: "$vuetify.layout.navigationSidebar.bookingDetails",
      parent: {
        name: "$vuetify.layout.navigationSidebar.booking",
        disabled: false,
        path: "/booking",
        exact: true,
      },
    },
  },
];
